import React from 'react';
import { Link } from 'react-router-dom';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
 Collapse, NavbarBrand, Navbar, NavItem, Nav
} from 'reactstrap';

import { routesDev, routesProd } from 'constants/navmenus';
import * as config from '../../../config';

type LogoType = {
  innerLink: string;
  imgSrc: string;
  imgAlt: string;
  outterLink: string;
};

interface ISidebarProps {
  role: string;
  logo: LogoType;
  toggleSidenav: () => {};
  sidenavOpen: boolean;
}

class Sidebar extends React.Component<ISidebarProps> {
  state = {
    openedCollapses: [''],
  };

  onMouseEnterSidenav = () => {
    if (!document.body.classList.contains('g-sidenav-pinned')) {
      document.body.classList.add('g-sidenav-show');
    }
  };

  onMouseLeaveSidenav = () => {
    if (!document.body.classList.contains('g-sidenav-pinned')) {
      document.body.classList.remove('g-sidenav-show');
    }
  };

  collapsesToggle = (collapse: string) => {
    const { openedCollapses } = this.state;
    if (openedCollapses.includes(collapse)) {
      this.setState({
        openedCollapses: [''],
      });
    } else {
      this.setState({
        openedCollapses: [collapse],
      });
    }
  };

  toggleCollapse = () => {
    this.setState((prevState: any) => ({
      collapseOpen: !prevState.collapseOpen,
    }));
  };

  linkStatus = (pathName: string, activeSatus: boolean) => {
    if (pathName === window.location.pathname) {
      return 'nav-link active-link';
    }
    if (activeSatus === true) {
      return 'nav-link';
    }
    return ' nav-link disabled-link';
  };

  createLinks = (links: any[]) => {
    const { role } = this.props;
    return (
      links
      && links.map((prop) => {
        // Hide application management nav for general user
        if (
          prop.name === 'applicationCollapse'
          && !['super_user', 'admin_user'].includes(role?.toLowerCase())
        ) {
          return null;
        }
        if (prop.collapse) {
          return (
            <NavItem key={prop.title}>
              <Link
                aria-expanded={this.state.openedCollapses.includes(prop.name)}
                className={
                  window.location.pathname.includes(prop.path)
                    ? 'nav-link active-link'
                    : 'nav-link'
                }
                data-toggle="collapse"
                onClick={() => {
                  this.collapsesToggle(prop.name);
                }}
                to={prop.path || '#'}
              >
                {prop.title && <span className="sidenav-normal">{prop.title} </span>}
              </Link>
              <Collapse isOpen={this.state.openedCollapses.includes(prop.name)}>
                <Nav className="nav-sm flex-column">{this.createLinks(prop.views)}</Nav>
              </Collapse>
            </NavItem>
          );
        }
        return (
          <NavItem key={prop.title}>
            <Link
              className={this.linkStatus(prop.path, prop.active)}
              onClick={() => {
                this.toggleCollapse();
              }}
              to={prop.path}
            >
              {prop.title && (
                <>
                  <span className="sidenav-mini-icon"> </span>
                  <span className="sidenav-normal"> {prop.title} </span>
                </>
              )}
            </Link>
          </NavItem>
        );
      })
    );
  };

  render() {
    const { logo } = this.props;
    let navbarBrandProps;
    if (logo && logo.innerLink) {
      navbarBrandProps = {
        to: logo.innerLink,
        tag: Link,
      };
    } else if (logo && logo.outterLink) {
      navbarBrandProps = {
        href: logo.outterLink,
        target: '_blank',
      };
    }
    const scrollBarInner = (
      <div className="scrollbar-inner">
        <div className="sidenav-header d-flex align-items-center">
          {logo ? (
            <NavbarBrand {...navbarBrandProps}>
              <img
                alt={logo.imgAlt}
                className="navbar-brand-img"
                src={logo.imgSrc}
                style={{ maxHeight: '5.5em' }}
              />
            </NavbarBrand>
          ) : null}
          <div className="ml-auto">
            <div
              aria-label="sidebar"
              className={
                this.props.sidenavOpen
                  ? 'sidenav-toggler d-none d-xl-block active'
                  : 'sidenav-toggler d-none d-xl-block '
              }
              onClick={this.props.toggleSidenav}
              onKeyDown={this.props.toggleSidenav}
              role="button"
              tabIndex={0}
            >
              <div className="sidenav-toggler-inner">
                <i className="sidenav-toggler-line" />
                <i className="sidenav-toggler-line" />
                <i className="sidenav-toggler-line" />
              </div>
            </div>
          </div>
        </div>
        <div className="navbar-inner mt-4">
          <Collapse
            isOpen
            navbar
          >
            <Nav navbar>
              {this.createLinks(config.default.app.isProduction ? routesProd : routesDev)}
            </Nav>
            <hr className="my-3" />
          </Collapse>
        </div>
      </div>
    );
    return (
      <Navbar
        className="sidenav navbar-vertical navbar-expand-xs navbar-light bg-white fixed-left "
        onMouseEnter={this.onMouseEnterSidenav}
        onMouseLeave={this.onMouseLeaveSidenav}
      >
        {navigator.platform.indexOf('Win') > -1 ? (
          <PerfectScrollbar>{scrollBarInner}</PerfectScrollbar>
        ) : (
          scrollBarInner
        )}
      </Navbar>
    );
  }
}

export default Sidebar;
